export { default as FooterDelivery } from "./FooterDelivery";